import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { ACC_PRODUCT_TEMPLATES } from '@/store/entities/schema_types';
import { accProductTemplatesClient as client } from '@/api/clients/admin';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters(ACC_PRODUCT_TEMPLATES),
  actions: {
    ...resourceActions,
    async load(ctx, { query = {} }) {
      try {
        const response = await client.list(query);

        const { data, meta } = response;

        const accProductTemplateIds = await ctx.dispatch(
          'entities/persistEntities',
          { type: ACC_PRODUCT_TEMPLATES, data },
          { root: true }
        );

        ctx.commit('setIds', accProductTemplateIds);
        ctx.commit('setMeta', meta);

        return Promise.resolve({ accProductTemplateIds, meta });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async store(ctx, { formData }) {
      try {
        const response = await client.store(mapKeysToSnakeCase(formData));

        const accProductTemplateId = await ctx.dispatch(
          'entities/persistEntities',
          { type: ACC_PRODUCT_TEMPLATES, data: response.data },
          { root: true }
        );

        return Promise.resolve(accProductTemplateId);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async read(ctx, { id, query = {} }) {
      try {
        const response = await client.read(id, query);

        const { data } = response;

        await ctx.dispatch(
          'entities/persistEntities',
          { type: ACC_PRODUCT_TEMPLATES, data },
          { root: true }
        );

        return Promise.resolve(true);
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async update(ctx, { id, formData }) {
      try {
        const response = await client.update(id, mapKeysToSnakeCase(formData));

        await ctx.dispatch(
          'entities/persistEntities',
          { type: ACC_PRODUCT_TEMPLATES, data: response.data },
          { root: true }
        );

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async destroy(ctx, id) {
      try {
        await client.destroy(id);

        await ctx.commit(
          'entities/removeEntity',
          { type: ACC_PRODUCT_TEMPLATES, id },
          { root: true }
        );

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
